/**
 * @generated SignedSource<<e652717db741a83a7d278c014e756b44>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdatePersonNotificationInput = {
  ids?: ReadonlyArray<string | null> | null;
  publisherPersonId?: number | null;
  subscriberPersonId?: number | null;
  entityType?: string | null;
  entityId?: number | null;
  publisherAction?: string | null;
  params?: string | null;
  createdAt?: string | null;
  all?: boolean | null;
  read?: boolean | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type updatePersonNotificationMutation$variables = {
  input: UpdatePersonNotificationInput;
};
export type updatePersonNotificationMutation$data = {
  readonly updatePersonNotification: {
    readonly viewer: {
      readonly recentNotifications: ReadonlyArray<{
        readonly id: string;
        readonly countId: number | null;
        readonly publisherPersonId: string;
        readonly subscriberPersonId: string;
        readonly publisherAction: string | null;
        readonly entityType: string | null;
        readonly entityId: number | null;
        readonly params: string | null;
        readonly createdAt: string | null;
        readonly read: boolean | null;
      } | null> | null;
      readonly unseenNotifications: number | null;
    } | null;
    readonly PersonNotifications: ReadonlyArray<{
      readonly id: string;
      readonly read: boolean | null;
    } | null> | null;
  } | null;
};
export type updatePersonNotificationMutation = {
  variables: updatePersonNotificationMutation$variables;
  response: updatePersonNotificationMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "read",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "PersonNotification",
  "kind": "LinkedField",
  "name": "recentNotifications",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "countId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "publisherPersonId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "subscriberPersonId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "publisherAction",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "params",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    (v3/*: any*/)
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unseenNotifications",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "PersonNotification",
  "kind": "LinkedField",
  "name": "PersonNotifications",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updatePersonNotificationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdatePersonNotificationPayload",
        "kind": "LinkedField",
        "name": "updatePersonNotification",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updatePersonNotificationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdatePersonNotificationPayload",
        "kind": "LinkedField",
        "name": "updatePersonNotification",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "34ab3676ffd1c215eb452f189bdd1c21",
    "id": null,
    "metadata": {},
    "name": "updatePersonNotificationMutation",
    "operationKind": "mutation",
    "text": "mutation updatePersonNotificationMutation(\n  $input: UpdatePersonNotificationInput!\n) {\n  updatePersonNotification(input: $input) {\n    viewer {\n      recentNotifications {\n        id\n        countId\n        publisherPersonId\n        subscriberPersonId\n        publisherAction\n        entityType\n        entityId\n        params\n        createdAt\n        read\n      }\n      unseenNotifications\n      id\n    }\n    PersonNotifications {\n      id\n      read\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "06eb7d55a2632c6f93e61cdfc91cf0b3";

export default node;
